import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11 17.2426L7.05025 13.2929C6.65972 12.9023 6.02656 12.9023 5.63603 13.2929C5.24551 13.6834 5.24551 14.3166 5.63603 14.7071L11.2929 20.3639C11.6834 20.7545 12.3166 20.7545 12.7071 20.3639L18.364 14.7071C18.7545 14.3166 18.7545 13.6834 18.364 13.2929C17.9734 12.9023 17.3403 12.9023 16.9497 13.2929L13 17.2426V4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V17.2426Z" })
});
export default SvgArrowDownLine;
